import { useEffect } from 'react'
import ChartCard from '../ChartCard'
import DateTable from '../DateTable'
import RegionCoordinator from '../RegionCoordinator'
import { useState } from 'react'
import { AnalyticsStore } from '../../../store'
import { observer } from 'mobx-react-lite'
import { useText } from '../../../texts'

const Graphic = observer(() => {
  const t = useText()
  useEffect(() => {
    if (!AnalyticsStore.chartsTabData) AnalyticsStore.getChartsTabData()
  }, [])
  const [activeChart, setActiveChart] = useState(null)
  const globalAnalytic = AnalyticsStore.chartsTabData?.global
  const regionCoordinators = AnalyticsStore.chartsTabData?.regionCoordinators
  const openChart = (i) => {
    AnalyticsStore.getChartsTabData(i)
    setActiveChart(i)
  }
  return (
    <div>
      {activeChart === null ? (
        <div>
          <div className="tab-title">{t('analytic')}</div>

          <div className="graphic-charts layout">
            <ChartCard
              chart={{
                title: t('evaluations-completed'),
                elements: [
                  { key: t('plan'), value: globalAnalytic?.allCount || 0 },
                  {
                    key: t('completed'),
                    value: globalAnalytic?.completedCount || 0,
                  },
                ],
              }}
              isLoading={!globalAnalytic}
            />
            <ChartCard
              chart={{
                title: t('appointment-quotas'),
                elements: [
                  {
                    key: t('assigned'),
                    value: globalAnalytic?.assignedCount || 0,
                  },
                  {
                    key: t('rcv-applics'),
                    value: globalAnalytic?.openCount || 0,
                  },
                ],
              }}
              chartValue={
                globalAnalytic &&
                (100 *
                  ((globalAnalytic?.assignedCount || 0) +
                    (globalAnalytic?.completedCount || 0))) /
                  (globalAnalytic?.allCount || 1).toFixed(0)
              }
              isLoading={!globalAnalytic}
            />
            <ChartCard
              chart={{
                title: t('yesterday-percent'),
                elements: [
                  {
                    key: t('completed'),
                    value: globalAnalytic?.completedCount,
                  },
                  {
                    key: t('yesterday-completed'),
                    value:
                      globalAnalytic?.calendarPlan[new Date().getDate() - 2]
                        ?.count || 0,
                  },
                ],
              }}
              chartValue={
                globalAnalytic &&
                (100 *
                  globalAnalytic?.calendarPlan[new Date().getDate() - 2]
                    ?.count || 0) /
                  (
                    globalAnalytic?.allCount - globalAnalytic.completedCount
                  ).toFixed(0)
              }
              isLoading={!globalAnalytic}
            />
          </div>

          {globalAnalytic && (
            <>
              <DateTable
                plan={globalAnalytic?.calendarPlan}
                visitsPlanned={globalAnalytic.allCount}
                visitsFact={globalAnalytic.completedCount}
              ></DateTable>

              <div className="tab-subtitle">{t('assistants')}</div>

              <div className="graphic-charts layout">
                {regionCoordinators && regionCoordinators.length > 0 ? (
                  regionCoordinators.map((user, i) => (
                    <ChartCard
                      openCard={() => {
                        openChart(i)
                      }}
                      key={i}
                      chart={{
                        title:
                          user.coordinator.firstName +
                          ' ' +
                          user.coordinator.surname,
                        elements: [
                          { key: t('plan'), value: user?.allCount || 0 },
                          {
                            key: t('completed'),
                            value: user?.completedCount || 0,
                          },
                        ],
                      }}
                    />
                  ))
                ) : (
                  <div className="lg-text grey-text">{t('not-available')}</div>
                )}
              </div>
            </>
          )}
        </div>
      ) : (
        <div>
          <RegionCoordinator
            back={() => setActiveChart(null)}
            asistance={regionCoordinators[activeChart]}
          ></RegionCoordinator>
        </div>
      )}
    </div>
  )
})

export default Graphic
